import { render } from "./SideNavItem.vue?vue&type=template&id=ca171c48"
import script from "./SideNavItem.vue?vue&type=script&lang=js"
export * from "./SideNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Development/lotte-deploy/cms-prod-lodash-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__